import type { FloorId } from './types';

/** Fixed service cavities. Their scratched grilles can be learned; only the creature fits. */
export interface PassageMouth {
  id: string;
  floor: FloorId;
  room: string;
  x: number;
  y: number;
}

// x/y are the left tile of a two-tile grille on a north wall.
export const PASSAGE_MOUTHS: PassageMouth[] = [
  { id: 'ground-west', floor: 'ground', room: 'westcorr', x: 31, y: 9 },
  { id: 'ground-east', floor: 'ground', room: 'corridor', x: 116, y: 44 },
  { id: 'second-west', floor: 'second', room: 'wcorr2', x: 32, y: 44 },
  { id: 'second-east', floor: 'second', room: 'ecorr2', x: 119, y: 44 },
  { id: 'basement-east', floor: 'basement', room: 'btunnel2', x: 107, y: 3 },
  { id: 'third-service', floor: 'third', room: 'corr3', x: 99, y: 29 },
  { id: 'attic-east', floor: 'attic', room: 'apass3', x: 74, y: 9 },
];

/** Bidirectional links, with real time spent travelling inside the wall. */
export const PASSAGE_LINKS: Array<{ a: string; b: string; seconds: number }> = [
  { a: 'ground-west', b: 'ground-east', seconds: 7.5 },
  { a: 'ground-west', b: 'second-west', seconds: 6 },
  { a: 'ground-east', b: 'second-east', seconds: 6 },
  { a: 'ground-east', b: 'basement-east', seconds: 6 },
  { a: 'second-west', b: 'second-east', seconds: 7.5 },
  { a: 'second-east', b: 'third-service', seconds: 6 },
  { a: 'third-service', b: 'attic-east', seconds: 7 },
];

export function passagePosition(p: PassageMouth): { floor: FloorId; x: number; y: number } {
  return { floor: p.floor, x: (p.x + 1) * 16, y: (p.y + 2) * 16 + 8 };
}
